import React from "react"
import { withRouter } from "routing"
import CancelButton from "./CancelButton"

const BackButton = ({ history, onCancel, ...props }) => (
  <CancelButton onCancel={onCancel || (() => history.goBack())} {...props} />
)

export default withRouter(BackButton)
